var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,1A19,19,0,1,1,1,20,19,19,0,0,1,20,1m0-1A20,20,0,1,0,40,20,20,20,0,0,0,20,0Z",
    fill: "#eaeaea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4,16.05l-12-9.6a.78.78,0,0,0-1,0l-12,9.6a.8.8,0,0,0,1,1.25L19.9,8.09,31.4,17.3a.82.82,0,0,0,.5.17.83.83,0,0,0,.63-.3A.8.8,0,0,0,32.4,16.05ZM10.3,17.82V29.47a.8.8,0,0,0,.8.8h7a8.19,8.19,0,0,1-.21-1.79A8,8,0,0,1,29.5,21.32v-3.5l-9.6-7.68Z",
    fill: "#444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.94,22.48a6,6,0,1,0,6,6A6,6,0,0,0,25.94,22.48Zm1,10h-2v-5h2Zm-1-6a1,1,0,1,1,1-1A.94.94,0,0,1,25.94,26.48Z",
    fill: "#ef5323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyInfo);
export default __webpack_public_path__ + "static/media/property_info.165c52457f388017dbad3afddb4f400f.svg";
export { ForwardRef as ReactComponent };